import { ChangeEvent } from 'react';
import { TextField, Grid, InputAdornment } from '@mui/material';
import FrequencySelect from '../../components/FrequencySelect';
import { MarkerIndex, ParsedMarker } from './types';

interface Props {
  markers: ParsedMarker[];
  markerAmplitudes: number[];
  handleMarkerInputClicked: (idx: MarkerIndex) => void;
  handleMarkerValueChanged: (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    idx: MarkerIndex
  ) => void;
  handleMarkerUnitChanged: (event: any, index: MarkerIndex) => void;
  handleMarkerNameChanged: (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    idx: MarkerIndex
  ) => void;

  disabled?: boolean;
}
const TrendlineMarkerConfigurationInputs = ({
  markers,
  markerAmplitudes,
  handleMarkerInputClicked,
  handleMarkerValueChanged,
  handleMarkerUnitChanged,
  handleMarkerNameChanged,
  disabled,
}: Props) => {
  return (
    <Grid container item spacing={1}>
      <Grid item xs={4} style={{ minWidth: '7rem' }}>
        <TextField
          id='marker1'
          label='Trendline Marker 1'
          type='number'
          inputProps={{ min: -1 }}
          name='marker1'
          placeholder='Trendline Marker 1'
          value={
            markers[100]?.x_pos_frequency_value >= 0
              ? markers[100]?.x_pos_frequency_value
              : ''
          }
          onClick={() => handleMarkerInputClicked(100)}
          onChange={(event) => handleMarkerValueChanged(event, 100)}
          variant='outlined'
          size='small'
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={2} style={{ minWidth: '6rem' }}>
        <FrequencySelect
          selected={markers[100]?.x_pos_frequency_unit || 'MHz'}
          onChange={(event) => handleMarkerUnitChanged(event, 100)}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={4} style={{ minWidth: '9.3rem' }}>
        <TextField
          id='marker1Value'
          name='marker1Value'
          placeholder='Amplitude'
          value={markerAmplitudes[100] || ''}
          variant='outlined'
          size='small'
          InputProps={{
            endAdornment: <InputAdornment position='end'>dBm</InputAdornment>,
          }}
          disabled={disabled}
        />
      </Grid>
      <Grid item container spacing={1}>
        <Grid item xs={4} style={{ minWidth: '7rem' }}>
          <TextField
            id='marker2'
            label='Trendline Marker 2'
            type='number'
            inputProps={{ min: -1 }}
            name='marker2'
            placeholder='Trendline Marker 2'
            value={
              markers[101]?.x_pos_frequency_value >= 0
                ? markers[101]?.x_pos_frequency_value
                : ''
            }
            onClick={() => handleMarkerInputClicked(101)}
            onChange={(event) => handleMarkerValueChanged(event, 101)}
            variant='outlined'
            size='small'
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={2} style={{ minWidth: '6rem' }}>
          <FrequencySelect
            selected={markers[1]?.x_pos_frequency_unit || 'MHz'}
            onChange={(event) => handleMarkerUnitChanged(event, 101)}
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={4} style={{ minWidth: '9.3rem' }}>
          <TextField
            id='marker2Value'
            name='marker2Value'
            placeholder='Amplitude'
            value={markerAmplitudes[101] || ''}
            variant='outlined'
            size='small'
            InputProps={{
              endAdornment: <InputAdornment position='end'>dBm</InputAdornment>,
            }}
            disabled={disabled}
          />
        </Grid>
      </Grid>
      <Grid item xs={4} style={{ minWidth: '7rem' }}>
        <TextField
          id='marker3'
          label='Trendline Marker 3'
          type='number'
          inputProps={{ min: -1 }}
          name='marker3'
          placeholder='Trendline Marker 3'
          value={
            markers[102]?.x_pos_frequency_value >= 0
              ? markers[102]?.x_pos_frequency_value
              : ''
          }
          onClick={() => handleMarkerInputClicked(102)}
          onChange={(event) => handleMarkerValueChanged(event, 102)}
          variant='outlined'
          size='small'
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={2} style={{ minWidth: '6rem' }}>
        <FrequencySelect
          selected={markers[102]?.x_pos_frequency_unit || 'MHz'}
          onChange={(event) => handleMarkerUnitChanged(event, 102)}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={4} style={{ minWidth: '9.3rem' }}>
        <TextField
          id='marker3Value'
          name='marker3Value'
          placeholder='Amplitude'
          variant='outlined'
          size='small'
          value={markerAmplitudes[102] || ''}
          InputProps={{
            endAdornment: <InputAdornment position='end'>dBm</InputAdornment>,
          }}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={4} style={{ minWidth: '7rem' }}>
        <TextField
          id='marker4'
          label='Trendline Marker 4'
          type='number'
          inputProps={{ min: -1 }}
          name='marker4'
          placeholder='Trendline Marker 4'
          value={
            markers[103]?.x_pos_frequency_value >= 0
              ? markers[103]?.x_pos_frequency_value
              : ''
          }
          onClick={() => handleMarkerInputClicked(103)}
          onChange={(event) => handleMarkerValueChanged(event, 103)}
          variant='outlined'
          size='small'
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={2} style={{ minWidth: '6rem' }}>
        <FrequencySelect
          selected={markers[103]?.x_pos_frequency_unit || 'MHz'}
          onChange={(event) => handleMarkerUnitChanged(event, 103)}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={4} style={{ minWidth: '9.3rem' }}>
        <TextField
          id='marker4Value'
          name='marker4Value'
          placeholder='Amplitude'
          value={markerAmplitudes[103] || ''}
          variant='outlined'
          size='small'
          InputProps={{
            endAdornment: <InputAdornment position='end'>dBm</InputAdornment>,
          }}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          id='marker1Name'
          name='marker1Name'
          placeholder='Trendline 1 Name'
          value={markers[100]?.name || ''}
          onChange={(event) => handleMarkerNameChanged(event, 100)}
          variant='outlined'
          size='small'
          fullWidth
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          id='marker2Name'
          name='marker2Name'
          placeholder='Trendline 2 Name'
          value={markers[101]?.name || ''}
          onChange={(event) => handleMarkerNameChanged(event, 101)}
          variant='outlined'
          size='small'
          fullWidth
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          id='marker3Name'
          name='marker3Name'
          placeholder='Trendline 3 Name'
          value={markers[102]?.name || ''}
          onChange={(event) => handleMarkerNameChanged(event, 102)}
          variant='outlined'
          size='small'
          fullWidth
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          id='marker4Name'
          name='marker4Name'
          placeholder='Trendline 4 Name'
          value={markers[103]?.name || ''}
          onChange={(event) => handleMarkerNameChanged(event, 103)}
          variant='outlined'
          size='small'
          fullWidth
        />
      </Grid>
    </Grid>
  );
};

export default TrendlineMarkerConfigurationInputs;
